import {Action} from '@reduxjs/toolkit'
import {persistReducer} from 'redux-persist'
import storage from 'redux-persist/lib/storage'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

export const actionTypes = {
  SetFilter: '[Floor SetFilter] Action',
  ResetFilter: '[Floor ResetFilter] Action',
}

const initialFloorState: IFloorState = {
  filter: {
    status: '',
    active: true,
  },
}

export interface IFloorState {
  filter?: {
    status: string
    active: boolean
  }
}

export const reducer = persistReducer(
  {storage, key: 'v100-Floor', whitelist: ['filter']},
  (state: IFloorState = initialFloorState, action: ActionWithPayload<IFloorState>) => {
    switch (action.type) {
      case actionTypes.ResetFilter: {
        return initialFloorState
      }

      case actionTypes.SetFilter: {
        const filter = action.payload?.filter
        return {...state, filter}
      }

      default:
        return state
    }
  }
)

export const Actions = {
  resetFilter: () => ({type: actionTypes.ResetFilter}),
  setFilter: (filter: object) => ({
    type: actionTypes.SetFilter,
    payload: {filter},
  }),
}

export function* saga() {}
